export default __webpack_public_path__ + "static/media/thumbnail.69cd9f58.png";